import type { IMessageEntity } from "../../shared/entities";

export interface IMessageEntityClass<E extends IMessageEntity> {
	toPlainObject(): E;

	updateTtl(v: number): void;
	updateLocalDttm(v: number): void;
	updateServerTime(v: number): void;
	updateContent(v: E["content"]): void;
	updateUrgency(v: any): void;
	updateE2eeStatus(v: number): void;
}

export abstract class MessageEntityClass<E extends IMessageEntity>
	implements IMessageEntityClass<E>
{
	protected type_: string;

	protected msgId_: string;

	protected cliMsgId_: string;
	protected fromUid_: string;
	protected toUid_: string;

	protected ttl_?: number;

	protected sendDttm_: number;

	protected localDttm_?: number;
	protected serverTime_?: number;

	protected urgency_?: any;

	protected e2eeStatus_?: number;

	constructor(
		type: string,
		msgId: string,
		cliMsgId: string,
		fromUid: string,
		toUid: string,
		sendDttm: number,
	) {
		this.type_ = type;

		this.msgId_ = msgId;

		this.cliMsgId_ = cliMsgId;
		this.fromUid_ = fromUid;
		this.toUid_ = toUid;

		this.sendDttm_ = sendDttm;
	}
	public abstract toPlainObject(): E;

	public updateTtl(v: number): void {
		//TODO: We should verify v value.
		this.ttl_ = v;
	}

	public updateLocalDttm(v: number): void {
		//TODO: We should verify v value.
		this.localDttm_ = v;
	}

	public updateServerTime(v: number): void {
		//TODO: We should verify v value.
		this.serverTime_ = v;
	}

	public abstract updateContent(v: E["content"]): void;

	public updateUrgency(v: any): void {
		//TODO: We should verify v value.
		this.urgency_ = v;
	}

	public updateE2eeStatus(v: number): void {
		//TODO: We should verify v value.
		this.e2eeStatus_ = v;
	}
}
